module.exports = __webpack_public_path__ + "static/media/setupmoneyicon.d5e77229.svg";